import {createSelector} from 'reselect'

import createCachedSelector from 're-reselect'
import {selectInputFields} from './entity'
import {getInputFieldStatus} from './utils'

export const selectInputFieldByName = createCachedSelector(
  selectInputFields,
  (state: any, inputFieldName: string) => inputFieldName,
  (inputFields, inputFieldName) =>
    inputFields.find(field => field.fieldName === inputFieldName) || null
)((state: any, inputFieldName: string) => inputFieldName)

export const selectInputFieldStatusByName = createCachedSelector(
  selectInputFieldByName,
  inputField => (inputField ? getInputFieldStatus(inputField) : null)
)((state: any, inputFieldName: string) => inputFieldName)

export const selectInputFieldNames = createSelector(
  selectInputFields,
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  inputFields => inputFields.map(inputField => inputField.fieldName!) as string[]
)

export const selectHasProvidedAllProvidableFields = createSelector(
  selectInputFields,
  inputFields =>
    inputFields.length > 0 &&
    inputFields.every(field => !Object.hasOwn(field, 'provided') || !!field?.provided)
)
